//main menu trigger
$(document).ready(function () {
    //main menu
    const modalTimeout = 300;
    const mainMenuTrigger = $('.main-menu-trigger');
    const mainMenuMobileDropdownTrigger = $('.js-mobile-dropdown-trigger');
    const secMenuMobileDropdownTrigger = $('.js-mobile-sec-dropdown-trigger');
    const mainMenu = $('.main-menu');
    const bodyContainer = $('body'); //$('#body-content');

    const copyKeyButton = $('.copy-key');
    // main menu trigger
    mainMenuTrigger.click(function () {
        $(mainMenuTrigger).toggleClass('active');
        $(mainMenu).toggleClass('is-mobile');
    });

    // mobile menu only  -toggle for secondary menus
    $(mainMenuMobileDropdownTrigger).each(function () {
        $(this).on('click', function () {
            if (mainMenu.hasClass('is-mobile')) {
                if ($(this).hasClass('is-active')) {
                    $(this)
                        .removeClass('is-active')
                        .next('div')
                        .slideUp();
                } else {
                    mainMenuMobileDropdownTrigger
                        .removeClass('is-active')
                        .next('div')
                        .slideUp();
                    $(this).addClass('is-active');
                    $(this)
                        .next('div')
                        .slideToggle();
                }
            }
        });
    });

    copyKeyButton.click(
        function () {
            var subscriptionId = $(this).data("subscription-id");
            var productKeyIdSelector = "#product-key";
            if (subscriptionId)
                productKeyIdSelector += "-" + subscriptionId;
            $(productKeyIdSelector).copyToClipboard();
        });

    $(secMenuMobileDropdownTrigger).each(function () {
        $(this).on('click', function () {
            $(this).toggleClass('is-active');
            $(this)
                .next('ul')
                .slideToggle();
        });
    });

    //download switch content
    const downloadTimelineBtn = document.querySelectorAll('.js-timeline-maker-download');
    const downloadTimelinePreContent = document.querySelectorAll('.js-timeline-pre-download');
    const downloadTimelinePostContent = document.querySelectorAll('.js-timeline-post-download');

    $(downloadTimelineBtn).click(function () {

        $(downloadTimelinePostContent).show();
        $(downloadTimelinePreContent).hide();
        downloadScroll();
        function downloadScroll() {
            $(document).scrollTop($(".header--download")[0].getBoundingClientRect().bottom + $(window).scrollTop());
        }
    });

    const tableCompareToggle = document.querySelectorAll('.js-compare-toggle');
    $(tableCompareToggle).each(function () {
        $(this).on('click', function () {
            $(this)
                .next('.comparison')
                .slideToggle('slow');
            $(this).toggleClass('is-active');
        });
    });    

    // accordion component
    let accordion = document.querySelectorAll('.accordion__item');
    $(accordion).each(function () {
        let accordionTitle = this.querySelector('.accordion__title');
        let accordionContent = this.querySelector('accordion__content');

        $(accordionTitle).click(function () {
            $(this).toggleClass('active');
            $(this)
                .next(accordionContent)
                .slideToggle('300');
        });
    });

    // tabs
    $('ul.tabs-nav li a').click(function (e) {
        e.preventDefault();
        var tab_id = $(this).attr('href');

        $('ul.tabs-nav li').removeClass('active');
        $('.tab-pane').removeClass('active');

        $(this)
            .parent()
            .addClass('active');
        $(tab_id).addClass('active');
    });

    // footer menu accordion
    $('.footer__menu ul li:first-child').each(function () {
        $(this).on('click', function () {
            if (isMobileOrTabletDevice()) {
                var jqSelf = $(this);
                var isVisible = jqSelf.siblings('li').is(':visible');
                if (isVisible) {
                    jqSelf.siblings('li').slideUp();
                } else {
                    $('.footer__menu ul li:not(:first-child)').slideUp();
                    jqSelf.siblings('li').slideDown();
                }
            }
        });
    });

    $('.js-copy-clipboard').click(function (e) {
        e.preventDefault();
        var jqSelf = $(this);
        var removeDone = function () {
            jqSelf.removeClass('done');
        };

        if (jqSelf.hasClass('done')) {
            removeDone()
        } else {
            jqSelf.addClass('done');
            jqSelf.find('.btn-copy__step-1').addClass('fade-in-animation');
            setTimeout(removeDone, 3000);
        }
    });

    //document pagination
    $(document).on('submit', '.pagination form', function (e) {
        var jqSelf = $(this);
        var jqPagination = jqSelf.closest('.pagination');
        var totalPages = Number(jqPagination.find('.total-pages').html());
        var currentPage = Number(jqPagination.find('#CurrentPage').attr('value'));
        var newCurrentPage = Number(jqPagination.find('#CurrentPage').val());

        if (1 > newCurrentPage || newCurrentPage > totalPages ||
            currentPage === newCurrentPage || isNaN(newCurrentPage)) {
            e.preventDefault();
            jqPagination.find('#CurrentPage').val(currentPage);
        }
    });

    $('.js-open-gallery').click(function (e) {
        e.preventDefault();
        $('.js-gallery').addClass('is-open');
        $('html, body').addClass('modal-open');
    });
    $('.js-close-gallery').click(function (e) {
        e.preventDefault();
        $('.js-gallery').removeClass('is-open');
        $('html, body').removeClass('modal-open');
    });

    // generic modal
    const openModals = '.js-open-modal';

    $(document).on('click', openModals, function (e) {
        e.preventDefault();
        e.stopPropagation();

        const scroolbarWidth = _getScrollbarWidth();

        if (scroolbarWidth > 0) {
            bodyContainer.css("padding-right", `${scroolbarWidth}px`);
        }

        var jqSelf = $(e.currentTarget);
        var modalElem = jqSelf.data('modal');

        if (modalElem) {
            var jqModalElem = $("#" + modalElem);
            toggleBodyScroll();

            jqModalElem.fadeIn(modalTimeout);
 
            const modalHeight = _getModalSrollbar()
            if (modalHeight < 0 && $('.modal__main').not('.opacity-0')) {
                $('.modal__main').not('.opacity-0').css("padding-right", '');
            } else {
                $('.modal__main').not('.opacity-0').css("padding-right", `${scroolbarWidth}px`);
            }

            // remove modal when clicking outside it
            $(document).bind('mousedown', hideAnyModal);
        }

    });

    // closing modal manually
    const modalClose = '.js-modal-close';
    $(document).on('click', modalClose, function (e) {
        hideCurrentModal($(this));
        if (!$(".modal:visible").exists()) {
            $(document).unbind('mousedown', hideAnyModal);
        }
    });

    // closing modal on Escape
    $(document).on('keydown', function (event) {
        if (event.key === "Escape") {
            hideCurrentModal($(".modal:visible").first());
            if (!$(".modal:visible").exists()) {
                $(document).unbind('mousedown', hideAnyModal);
            }
        }
    });

    $(window).resize(function (e) {
        resizeFooterNavigation();
    });
});

function hideCurrentModal(jqHide) {
    jqHide.closest('.modal').fadeOut('1000');
    closeSubscriptionSlider(jqHide);
    hideModalUnderSeeExamples();
    updatePaddingOnModalClose();
    $(document).unbind('mousedown', hideAnyModal);
}

function hideAnyModal(event) {
    var jqSelf = $(event.target);
    var isOutsideModal = !jqSelf.closest(".modal__box").exists();
    var isModalScrollBar = jqSelf.hasClass("modal__main");
    var isOutsideConsentBanner = !jqSelf.closest('.cc-window').exists();
    if (isOutsideModal && isOutsideConsentBanner && !isModalScrollBar) {
        var jqModal = $('.modal__box:visible').first();
        if (jqModal.exists()) {
            var modal = jqModal.closest('.modal').not('[data-check-login-modal]');

            // Hide only the modals that are most top of the elements
            var modalZIndex = parseFloat(modal.css('z-index')) || 0;
            var targetZIndex = jqSelf.getZIndexOfNearestParent() || 0;

            if (modalZIndex >= targetZIndex) {
                modal.fadeOut('1000');
                closeSubscriptionSlider(modal);
                hideModalUnderSeeExamples();
                updatePaddingOnModalClose();
            }
        }

        if (!$(".modal:visible").exists()) {
            $(document).unbind('mousedown', hideAnyModal);
        }
    }
}

function _getScrollbarWidth() {
    const bodyWidth = document.body.getBoundingClientRect().width
    const scrollbarWidth = window.innerWidth - bodyWidth
    return scrollbarWidth
}

//check if the modal is high enough to add a scrollbar
function _getModalSrollbar() {
    const windowHeight = $(window).height()
    const modalHeight = $('.modal__main:visible > .modal__container').outerHeight()
    const modalScrollbarHeight = windowHeight - modalHeight
    return modalScrollbarHeight
}

//close modal and apply the required padding to it
function updatePaddingOnModalClose() {
    const isOverflowVisible = $("html").hasClass("overflow-hidden");
    if (!isOverflowVisible) {
        $('body').css("padding-right", '');
    
    const scroolbarWidth = _getScrollbarWidth();
    const modalHeight = _getModalSrollbar()

    if (modalHeight <= 0) {
        $('.modal__main').not('.opacity-0').css("padding-right", '');
    } else {
        $('.modal__main').not('.opacity-0').css("padding-right", `${scroolbarWidth}px`);
        }
    }
}

function isMobileOrTabletDevice() {
    return window.matchMedia("(max-width: 991.98px)").matches;
}

function resizeFooterNavigation() {
    $('.footer__menu ul > li:first-child').each(function (ind, el) {
        var jqSelf = $(el);
        var isVisible = jqSelf.siblings('li').is(':visible');
        if (isMobileOrTabletDevice()) {
            jqSelf.siblings('li').slideUp();
        } else {
            jqSelf.siblings('li').slideDown();
        }
    });
}

function toggleBodyScroll() {
    if ($("html").hasClass("overflow-hidden") && $(".modal").is(":visible")) {
        if (!$("#basic-pro-plus-slider").is(":visible")) {
            return;
        } else {
            $("html").removeClass("overflow-hidden");
        }

    } else {
        $("html").addClass("overflow-hidden");
    }
};

function closeSubscriptionSlider(target) {
    if ($(target).attr("data-modal") == "basic-pro-plus-slider") {
        $("html").addClass("overflow-hidden");
    } else {

        if ($(target).closest("#basic-pro-plus-slider").exists()) {
            return;
        } else {
            $("html").removeClass("overflow-hidden");
        }
    }

};

//check if the See Examples modal is opened (on subscriptions)
function hideModalUnderSeeExamples() {
    if ($("#basic-pro-plus-slider").is(":visible") || $("#basic-pro-plus-slider").siblings(".modal").hasClass("opacity-0")) {
        $("#basic-pro-plus-slider").siblings(".modal").removeClass("opacity-0");
    }
}